import { useLocation } from "react-router-dom";
import { PanelLeft, Search, Building2 } from "lucide-react";
import { useUiStore } from "@/store/uiStore";
import { useAuth } from "@/contexts/AuthContext";
import { ROUTE_TITLES } from "@/shared/nav";
import { useLabels } from "@/lib/relabel";
import { ThemeToggle } from "./ThemeToggle";
import { NotificationBell } from "./NotificationBell";
import { UserMenu } from "./UserMenu";
import { VerticalSwitcher } from "./VerticalSwitcher";

export function TopBar() {
  const toggleSidebar = useUiStore((s) => s.toggleSidebar);
  const setPaletteOpen = useUiStore((s) => s.setPaletteOpen);
  const { user } = useAuth();
  const { pathname } = useLocation();
  const { nav } = useLabels();
  const title = nav(ROUTE_TITLES[pathname] || "AssortIQ");

  return (
    <header
      data-testid="app-topbar"
      className="sticky top-0 z-30 h-16 bg-card/95 backdrop-blur border-b flex items-center gap-3 px-4 sm:px-6"
    >
      <button
        data-testid="sidebar-toggle"
        onClick={toggleSidebar}
        className="hidden lg:inline-flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-foreground transition-colors"
      >
        <PanelLeft className="h-[18px] w-[18px]" />
      </button>

      <div className="min-w-0">
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Building2 className="h-3.5 w-3.5" />
          <span className="truncate">{user?.org_name || "Organization"}</span>
          <VerticalSwitcher />
        </div>
        <h1 className="text-base font-heading font-bold leading-tight truncate">{title}</h1>
      </div>

      <div className="flex-1" />

      <button
        data-testid="global-search-trigger"
        onClick={() => setPaletteOpen(true)}
        className="hidden sm:flex items-center gap-2 h-9 rounded-md border bg-background px-3 text-sm text-muted-foreground hover:bg-accent transition-colors w-56"
      >
        <Search className="h-4 w-4" />
        <span className="flex-1 text-left">Search…</span>
        <kbd className="pointer-events-none rounded border bg-muted px-1.5 py-0.5 text-[10px] font-mono">⌘K</kbd>
      </button>
      <button
        data-testid="global-search-trigger-mobile"
        onClick={() => setPaletteOpen(true)}
        className="sm:hidden h-9 w-9 inline-flex items-center justify-center rounded-md text-muted-foreground hover:bg-accent transition-colors"
      >
        <Search className="h-[18px] w-[18px]" />
      </button>

      <ThemeToggle />
      <NotificationBell />
      <div className="w-px h-6 bg-border mx-0.5" />
      <UserMenu />
    </header>
  );
}

export default TopBar;
